
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexdnw5CgoUihkXnbTbZ1GfE_4587VkdN0ykfny7JbApvxo8Meta } from "/Volumes/omar-projects/projects/mvp/mvp-website-new/pages/index.vue?macro=true";
import { default as thankyoucwha2WdMmKKWYKS2BNpVV9sgyhshLuIHqqTViFf1_U8Meta } from "/Volumes/omar-projects/projects/mvp/mvp-website-new/pages/thankyou.vue?macro=true";
import { default as no_45interestnPi3zdveAB8IhPoce6EDZVWs0VCFDM_CYAvnfWV8Vu0Meta } from "/Volumes/omar-projects/projects/mvp/mvp-website-new/pages/no-interest.vue?macro=true";
import { default as privacy_45policyG5HzH4sVtoBTE8dHKvehbdpBMsKzcmywWInAoY1_TkwMeta } from "/Volumes/omar-projects/projects/mvp/mvp-website-new/pages/privacy-policy.vue?macro=true";
import { default as thankyou_45for_45respondingYooNB9VvkpYUth8NDe8G9ufkXRqwWSNvA2_YQaWMxkkMeta } from "/Volumes/omar-projects/projects/mvp/mvp-website-new/pages/thankyou-for-responding.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/Volumes/omar-projects/projects/mvp/mvp-website-new/pages/index.vue")
  },
  {
    name: "thankyou",
    path: "/thankyou",
    component: () => import("/Volumes/omar-projects/projects/mvp/mvp-website-new/pages/thankyou.vue")
  },
  {
    name: "no-interest",
    path: "/no-interest",
    component: () => import("/Volumes/omar-projects/projects/mvp/mvp-website-new/pages/no-interest.vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    component: () => import("/Volumes/omar-projects/projects/mvp/mvp-website-new/pages/privacy-policy.vue")
  },
  {
    name: "thankyou-for-responding",
    path: "/thankyou-for-responding",
    component: () => import("/Volumes/omar-projects/projects/mvp/mvp-website-new/pages/thankyou-for-responding.vue")
  }
]